import { useState } from "react";
import { toast } from "sonner";
import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import { useLang } from "../../lib/i18n";
import { useContent } from "../../lib/useFetch";
import { api, errMsg } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";
import { PageHeader } from "./About";

export default function Contact() {
  const { t, trc } = useLang();
  const c = useContent();
  const site = c.site?.fields || {};
  const [f, setF] = useState({ name: "", email: "", subject: "", message: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/public/contact", f);
      toast.success(t("sent_ok"));
      setF({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  const items = [[Mail, site.email, `mailto:${site.email}`], [Phone, `${site.head_coach} · ${site.phone}`, `tel:${site.phone}`], [MessageCircle, "WhatsApp", site.whatsapp_url], [MapPin, trc(c, "contacts", "address")]];
  return (
    <div data-testid="contact-page">
      <PageHeader eyebrow={t("nav_contacts")} title={t("contact_title")} sub={trc(c, "contacts", "intro")} />
      <section className="container-x grid gap-12 py-20 lg:grid-cols-12">
        <div className="space-y-4 lg:col-span-5">
          {items.map(([Icon, label, href], i) => (
            <a key={i} href={href} target="_blank" rel="noreferrer" className="flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-5 transition-colors hover:border-[#00A8B5]">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-cyan-50 text-[#00A8B5]"><Icon size={20} /></span>
              <span className="font-semibold text-[#0A2540]">{label}</span>
            </a>
          ))}
        </div>
        <form onSubmit={submit} className="space-y-4 rounded-3xl border border-slate-200 bg-white p-8 shadow-xl lg:col-span-7" data-testid="contact-form">
          <div className="grid gap-4 md:grid-cols-2">
            <Input required placeholder={t("name")} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="contact-name" />
            <Input required type="email" placeholder={t("email")} value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="contact-email" />
          </div>
          <Input placeholder={t("subject")} value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} data-testid="contact-subject" />
          <Textarea required rows={6} placeholder={t("message")} value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} data-testid="contact-message" />
          <button disabled={busy} className="btn-buoy disabled:opacity-60" data-testid="contact-submit">{t("send")}</button>
        </form>
      </section>
    </div>
  );
}
